import React from 'react';
import GameQuery from '../../query/GameQuery';
import BalanceSheet from '../../components/BalanceSheet';
import { Route } from 'react-router-dom';
import { BALANCESHEET } from '../../routes';

const BalanceSheetRoute = () => (
	<GameQuery>
		{({ game }) => (
			<Route
				path={BALANCESHEET}
				render={props => <BalanceSheet {...props} game={game} />}
			/>
		)}
	</GameQuery>
);

export default BalanceSheetRoute;
